// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__TkYc2","colCheckbox":"styles_colCheckbox__1MJmE"};